<div class="col-12">
  <a (click)="onGoBack()"
    class="btn btn--link btn--link--secondary btn--link--secondary--bold btn--link--secondary--big btn--link--secondary--left pl-0">
    <img class=" title-navigation-fix-align" src="assets/img/arrow_l_g.png" alt="">Rechazar licencia</a>
</div>
<div class="col-12 col-md-4 mt-4">
  <div class="form form--required">
    <app-text-area
    [whitePanel]="true"
    [controlForm]="controlForm"
    [title]="'Ingresa el motivo del rechazo de la licencia'"
    [placeholder]="'Comentario'"
    [maxlength]="300"></app-text-area>
  </div>
</div>
<div class="col-12 u-mt10 mb-2">
  <button
    type="button"
    class="btn btn--primary modal__trigger px-5"
    [ngClass]="controlForm.valid ? '' : 'btn--disabled'"
    (click)="onSubmit()"
  >
    Ingresar
  </button>
</div>
